.surface {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.thread {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-4);
  padding: var(--hcr-spacing-2) 0 var(--hcr-spacing-4);
}
